export default "__VITE_ASSET__ChAxkVHn__"